import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const STATUSES = [
  { key: "saved", label: "Saved", color: "#71717A" },
  { key: "applied", label: "Applied", color: "#002FA7" },
  { key: "interviewing", label: "Interviewing", color: "#F59E0B" },
  { key: "offer", label: "Offer", color: "#10B981" },
  { key: "rejected", label: "Rejected", color: "#EF4444" },
];

export const statusColor = (s) =>
  STATUSES.find((x) => x.key === s)?.color || "#71717A";

export const statusLabel = (s) =>
  STATUSES.find((x) => x.key === s)?.label || s;

export const CURRENCIES = [
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "GBP", symbol: "£" },
  { code: "INR", symbol: "₹" },
  { code: "CAD", symbol: "C$" },
  { code: "AUD", symbol: "A$" },
  { code: "SGD", symbol: "S$" },
];

export const SALARY_PERIODS = [
  { key: "hour", label: "Per hour" },
  { key: "day", label: "Per day" },
  { key: "week", label: "Per week" },
  { key: "month", label: "Per month" },
  { key: "year", label: "Per year" },
];

export const EMPLOYMENT_TYPES = [
  { key: "full_time", label: "Full-time" },
  { key: "part_time", label: "Part-time" },
  { key: "contract", label: "Contract" },
  { key: "internship", label: "Internship" },
];

export const employmentLabel = (k) =>
  EMPLOYMENT_TYPES.find((x) => x.key === k)?.label || "";

export const PRIORITIES = [
  { key: "highest", label: "Highest", color: "#DC2626" },
  { key: "high", label: "High", color: "#F97316" },
  { key: "medium", label: "Medium", color: "#71717A" },
  { key: "low", label: "Low", color: "#3B82F6" },
  { key: "lowest", label: "Lowest", color: "#A1A1AA" },
];

export const PRIORITY_ORDER = PRIORITIES.reduce((acc, p, i) => ({ ...acc, [p.key]: i }), {});

export const priorityLabel = (k) =>
  PRIORITIES.find((x) => x.key === k)?.label || "Medium";

export const priorityColor = (k) =>
  PRIORITIES.find((x) => x.key === k)?.color || "#71717A";

export const locationSuffix = (job) => {
  if (job.remote) return " · Remote";
  if (job.location) return ` · ${job.location}`;
  return "";
};
